// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3gceK","requiredAsterisk":"Info_requiredAsterisk__1qLYw"};